import { render } from "./TeamSvg.vue?vue&type=template&id=0d8ef479"
const script = {}

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__